import { Image, Flex, Button, Text } from "@chakra-ui/react";

const ThemeButton = ({ name, src, onClick, id, themeSelected, ...rest }) => {
  const isSelected = () => themeSelected === id;

  return (
    <Flex direction="column" alignItems="center" w="33%" {...rest}>
      <Button
        height={["100px", null, "120px"]}
        width={["100px", null, "120px"]}
        borderRadius="100%"
        overflow="hidden"
        p={0}
        m={0}
        boxShadow={isSelected() ? "0 1px 2px 4px #215342" : "none"}
        _focus={{
          boxShadow: "0 1px 2px 4px #215342",
          color: "#EFEBE1",
        }}
        transition="all .1s ease-in-out"
        onClick={onClick}
      >
        <Image src={src} objectFit="cover" />
      </Button>
      <Text
        textAlign="center"
        mt={4}
        maxW={["100%", null, "80%"]}
        color={isSelected() ? "#215342" : "#331F12"}
        fontFamily={isSelected() ? "JosefinBold" : "JosefinRegular"}
        fontSize="md"
        lineHeight="16px"
        fontWeight="bold"
      >
        {name}
      </Text>
    </Flex>
  );
};

export default ThemeButton;
